import React, { PropTypes } from 'react';
import { Field, initialize, reduxForm, reset, SubmissionError } from 'redux-form';
import RenderField from '../../../../FormTemplate/InputControl';
import RenderTextArea from '../../../../FormTemplate/TextareaControl';
import Select from '../../../../FormTemplate/Select';
import { Button } from 'react-bootstrap';
import axios from './../../../../../constants/axios';
import alert from 'alertify.js';

@reduxForm({
   form: 'productSubEditGeneralInfoForm'
})
class ProductSubEditGeneralInfoForm extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         product: {}
      };
   }

   componentDidMount() {
      const { productId } = this.props.params;
      return axios
         .get(`items/productSub/getGeneralInfoById/${productId}`)
         .then((res) => {
            this.props.dispatch(initialize('productSubEditGeneralInfoForm', res.data, true));
            this.setState({
               product: res.data
            });
         });
   }

   updateGeneralInfo = (generalInfo) => {
      const { productId } = this.props.params;
      const data = Object.assign({}, generalInfo, {
         id: productId,
         mother_id: this.state.product.mother_id
      });
      return axios.post('items/productSub/updateGeneralInfo', data)
         .then((res) => {
            if (res.status === 201) {
               alert.success('Product Updated.');
               this.props.dispatch(initialize('productSubEditGeneralInfoForm', data, true));
               this.props.dispatch(reset('productSubEditGeneralInfoForm'));
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { product } = this.state;
      const { handleSubmit, submitting, pristine, invalid } = this.props;
      return (
         <form noValidate autoComplete="off" onSubmit={handleSubmit(this.updateGeneralInfo)} >
            <h3 >Sub Product General Information</h3 >
            <h4 >Mother Product: {product.mother_name}</h4 >
            <hr />
            <Field name="sub_item_variant" component={RenderField} type="text" label="Sub Product Variant" />
            <Field name="barcode" component={RenderField} type="text" label="Barcode" />
            <Field name="description" component={RenderTextArea} rows="7" label="Sub Product Description" />
            <Field name="active" component={Select}
                   options={[{ value: 1, label: "Active" }, { value: 0, label: "In Active" }]}
                   label="Active / InActive" />
            <Button type="submit" bsStyle="success" block
                    disabled={submitting || pristine || invalid} >Update</Button >
         </form >
      );
   }
}

ProductSubEditGeneralInfoForm.propTypes = {
   handleSubmit: PropTypes.func,
   params: PropTypes.object,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func
};


export default ProductSubEditGeneralInfoForm;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Product/ProductSub/ProductSubEdit/ProductSubEditGeneralInfoForm.js
 **/